import { render, staticRenderFns } from "./addIpfr.vue?vue&type=template&id=71caa517"
import script from "./addIpfr.vue?vue&type=script&lang=js"
export * from "./addIpfr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports